export default function niagaraReducer(state = [], action) {
  switch (action.type) {
    case "FETCH_NIAGARA":
      return [].concat.apply([], [...state, action.payload]);
    default:
      return state;
  }
}
